import { Get, Post } from "services";
import { ApiPath } from "paths";

export const searchCancelationReport = async (body) => {
  const res = await Get(`${ApiPath.SEARCH_CANCEL_TICKETS}`, body);
  return res;
};

export const cancelTicketRequest = async (body) => {
  const res = await Post(`${ApiPath.CANCEL_TICKET}`, body);
  return res;
}